import { useEffect } from 'react'
import { useLocation } from "react-router-dom"
import { useReducedMotionSafe } from "../lib/motion"

// Mounted once at the app root. Plain BrowserRouter doesn't reset scroll
// position on route change (only full page loads do that natively), so
// every internal link/button that navigates to a different page would
// otherwise land wherever the previous page happened to be scrolled.
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const reducedMotion = useReducedMotionSafe();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: reducedMotion ? "instant" : "smooth" });
    }, [pathname, reducedMotion]);

    return null;
}

export default ScrollToTop
